<template>
  <div class="dashboard-view">
    <v-main class="dashboard-content">
      <v-container fluid>
        <!-- Content Container -->
        <content-container />
      </v-container>
    </v-main>

    <!-- Dialog -->
    <DialogContainer />
    <!-- Alert Dialog -->
    <AlertDialog />
    <!-- Toast Container -->
    <ToastContainer />
  </div>
</template>

<script>
// components
import ContentContainer from '@/components/_core/Containers/Content_Container'
import DialogContainer from '@/components/_core/Containers/Dialog_Container'
import AlertDialog from '@/components/_core/Containers/Alert_Container.vue'
import ToastContainer from '@/components/_core/Containers/Toast_Container.vue'

export default {
  name: 'dashboard-view',

  components: {
    AlertDialog,
    ContentContainer,
    DialogContainer,
    ToastContainer
  }
}
</script>

<style lang="scss">
.dashboard-view {
  height: 100vh;
  width: 100vw;
  max-width: 100%;
  overflow: hidden;

  .dashboard-content {
    height: 100%;

    .v-container {
      height: 100%;
      padding: 0 !important;
      margin: 0 !important;
    }
  }
}
</style>
